import type { ErrorInfo } from 'react'
import { ENV } from '@services/env'
import { logApiError, logInfo, JSError } from '@services/logging.service'

/**
 * ErrorBoundary `onError`. Mirrors process-runner: map the thrown error's
 * `name` to a `JSError` (fallback `InternalError`) and post it to the server —
 * but only in dev, matching process-runner's `APP_ENV === 'dev'` gate. The
 * comm-service endpoint is `@Profile({"!prod"})` so this is inert in prod
 * regardless. Logging failures are swallowed so a crash screen still renders.
 */
export function errorHandler(error: unknown, info: ErrorInfo) {
  const name = error instanceof Error ? error.name : undefined
  const jsError =
    name && name in JSError
      ? JSError[name as keyof typeof JSError]
      : JSError.InternalError

  if (ENV.isDev) {
    logApiError(jsError)
      .then(() => logInfo('error log to server', info.componentStack))
      .catch(() => {})
  }
}
